"use client";
import type { SxProps, Theme } from "@mui/material/styles";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";

interface Props {
  sx?: SxProps<Theme>;
  height?: number | string;
}

export default function YotoLovesCantecelul({ sx, height = 120 }: Props) {
  return (
    <Stack
      direction="row"
      spacing={4}
      sx={[{
        alignItems: "center",
        justifyContent: "center"
      }, ...(Array.isArray(sx) ? sx : [sx])]}>
      <Box
        component="img"
        src="/we-love-yoto.png"
        alt="Cântecelul Meu"
        onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
          e.currentTarget.style.display = "none";
        }}
        sx={{ objectFit: "contain", height }}
      />
    </Stack>
  );
}
